import React from 'react'
import { Grid, GridItem } from '../../components/grid'
import css from './style.css'
import capitalize from 'lodash/capitalize'

const shapes = [
  ['round', 'cushion', 'princess', 'oval', 'emerald', 'asscher'],
  ['pear', 'radiant', 'marquise', 'heart', 'trilliant']
]

const DiamondShapes = () => (
  <div>
    {shapes.map((shapeList, index) => (
      <Grid key={`shapeList${index}`} customStyle={css.group}>
        {shapeList.map((shape, index, list) => (
          <GridItem customStyle={css.shape} key={`shape${index}`} col={`1/${list.length}`}>
            <img
              src={require(`./images/${shape}.png`)}
              srcSet={[
                require(`./images/${shape}.png`) + ' 1x',
                require(`./images/${shape}@2x.png`) + ' 2x'
              ].join(', ')}
            />
            <p className={css.text}>{capitalize(shape)}</p>
          </GridItem>
        ))}
      </Grid>
    ))}
  </div>
)

export default DiamondShapes



// WEBPACK FOOTER //
// ./src/components/diamond-shapes/index.js